import { render, staticRenderFns } from "./PaymentBooking.vue?vue&type=template&id=4f5e1d22&scoped=true&"
import script from "./PaymentBooking.vue?vue&type=script&lang=js&"
export * from "./PaymentBooking.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBooking.vue?vue&type=style&index=0&lang=scss&"
import style1 from "@/assets/css/success.css?vue&type=style&index=1&id=4f5e1d22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5e1d22",
  null
  
)

export default component.exports